module.exports = __webpack_public_path__ + "img/jingan.f957dbab.jpg";